import React from "react";
import { Fragment, useState } from "react";
import { Dialog, Menu, Transition, Disclosure } from "@headlessui/react";
import {
  Link,
  Navigate,
  useSearchParams,
  useLocation,
  useParams,
} from "react-router-dom";
import mainLogo from "../mglogo.png";
import {
  BellIcon,
  CalendarIcon,
  ChartBarIcon,
  FolderIcon,
  HomeIcon,
  InboxIcon,
  PencilIcon,
  LinkIcon,
  PaperClipIcon,
  MenuAlt2Icon,
  ShoppingBagIcon,
  UsersIcon,
  XIcon,
  ArchiveIcon,
  ClipboardIcon,
  ShoppingCartIcon,
  TemplateIcon,
  DocumentIcon,
} from "@heroicons/react/outline";
import {
  CheckCircleIcon,
  SearchIcon,
  DotsVerticalIcon,
  CheckIcon,
  ColorSwatchIcon,
  CogIcon,
} from "@heroicons/react/solid";
import axios from "axios";


function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
const projects = [
  {
    id: 1,
    name: "New Advertising Campaign",
    hours: "12.0",
    rate: "$75.00",
    price: "$900.00",
  },
  // More projects...
];
class Purchaseorderview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebarOpen: false,
      setSidebarOpen: false,
      showmsg: false,
      msg: "",
      logoutRedirect: false,
      success: false,
      redirect: false,
      commonGSTvalue: 0,
      error_list: [],
      purchaseOrderreceivedModal: false,
      purchase_order_id: "",
      purchase_order_received_date: "",
      purchaseorderDetails: [],
      vendorDetails: [],
      brachDetails: [],
      billingAddress: [],
      items: [],
      totalTaxamount: [],
      branchState: [],
      branchCountry: [],
      vendorState: [],
      vendorCountry: [],
      purchaseorderId: [],
      paymentList: [],
      paymentTerm: "",
      vendorgstin: "",
      purchaseordertobill: false,
      loader: "",
      overLay: "",
      purchaseordereditLink:"/crm/filterby/Purchaseorderedit/",
    };
  }

  setLoaderFunction = (e) => {
    this.setState({ loader: "" });
    this.setState({
      overLay: "fixed inset-0 bg-black/30",
    });
  };
  closeLoaderFuncion = (e) => {
    this.setState({ loader: "" });
    this.setState({
      overLay: "",
    });
  };
  close = async (e) => {
    this.setState({ sidebarOpen: false });
  };
  open = async (e) => {
    console.log("open")
    this.setState({ sidebarOpen: true });
  };

  async componentDidMount() {
    this.setLoaderFunction();
    const token = localStorage.getItem("token");
    const { id } = this.props.params;
    this.setState({ purchaseorderId: id });
    const ress = axios
      .get("public/api/purchase/order/edit/" + id, {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((ress) => {
        this.state.commonGSTvalue =
          ress.data.purchase_order.purchase_order_items[0].gst_igst_common_value;

        this.setState({
          purchaseorderDetails: ress.data.purchase_order,
          vendorDetails: ress.data.purchase_order.vendor_details_for_edit,
          brachDetails: ress.data.purchase_order.branch,
          branchState: ress.data.purchase_order.branch.state_union_territory,
          branchCountry:
            ress.data.organization_profile.business_location_country,
          billingAddress:
            ress.data.purchase_order.vendor_details_for_edit.vendor_address,
          vendorgstin:
            ress.data.purchase_order.vendor_details_for_edit
              .vendor_other_detail,
          vendorState:
            ress.data.purchase_order.vendor_details_for_edit.vendor_address
              .billing_state_name,
          vendorCountry:
            ress.data.purchase_order.vendor_details_for_edit.vendor_address
              .billing_country_name,
          items: ress.data.purchase_order.purchase_order_items,
          totalTaxamount: ress.data.purchase_order.item_tax_total,

          commonGSTvalue:
            ress.data.purchase_order.purchase_order_items[0]
              .gst_igst_common_value,
          paymentTerm: ress.data.purchase_order.payment_terms_name,
          loader: "",
          paymentList: ress.data.purchase_order.purchase_order_received_state,
        });
      });
    this.closeLoaderFuncion();
  }

  componentDidUpdate(prevProps, prevState, snapshot){
   
    if(this.state.deleteRedirect==true){
      this.setState({deleteRedirect:false});
      const token = localStorage.getItem("token");
      const { id } = this.props.params;
    
    const ress = axios
      .get("public/api/purchase/order/edit/" + id, {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((ress) => {
        this.state.commonGSTvalue =
          ress.data.purchase_order.purchase_order_items[0].gst_igst_common_value;

        this.setState({
          purchaseorderDetails: ress.data.purchase_order,
          vendorDetails: ress.data.purchase_order.vendor_details_for_edit,
          brachDetails: ress.data.purchase_order.branch,
          branchState: ress.data.purchase_order.branch.state_union_territory,
          branchCountry:
            ress.data.organization_profile.business_location_country,
          billingAddress:
            ress.data.purchase_order.vendor_details_for_edit.vendor_address,
          vendorgstin:
            ress.data.purchase_order.vendor_details_for_edit
              .vendor_other_detail,
          vendorState:
            ress.data.purchase_order.vendor_details_for_edit.vendor_address
              .billing_state_name,
          vendorCountry:
            ress.data.purchase_order.vendor_details_for_edit.vendor_address
              .billing_country_name,
          items: ress.data.purchase_order.purchase_order_items,
          totalTaxamount: ress.data.purchase_order.item_tax_total,

          commonGSTvalue:
            ress.data.purchase_order.purchase_order_items[0]
              .gst_igst_common_value,
          paymentTerm: ress.data.purchase_order.payment_terms_name,
          loader: "",
          paymentList: ress.data.purchase_order.purchase_order_received_state,
        });
      });
  }}

  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  converttobill = (e) => {
    this.setState({ purchaseordertobill: true });
  };

  Received = async (e) => {
    e.preventDefault();
    const id = this.state.purchaseorderDetails.id;
    //this.setState({purchase_order_id:id});
    this.state.purchase_order_id = id;
    var token = localStorage.getItem("token");
    const headers = {
      authorization: `Bearer ${token}`,
      Accept: "application/json",
    };

    const res = await axios.post(
      "public/api/purchase/order/received/state/store",
      this.state,
      { headers }
    );

    if (res.data.success) {
      this.setState({ showmsg: true });
      this.setState({ purchaseOrderreceivedModal: false });
      this.setState({ msg: "Purchase Order Status updated to Received" });
      
    } else {
      this.setState({ error_list: res.data.data });
      //this.setState({ show: true })
    }
  };

  Receivedmodal = (e) => {
    this.setState({ purchaseOrderreceivedModal: true });
  };

  handlereceivedInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  billViewNullfunction = (e) => {
    if (e == null) {
      return " ";
    } else {
      return e;
    }
  };
  billViewNullfunctionState = (e) => {
    if (e == null) {
      return " ";
    } else {
      if (e.name == null) {
        return "";
      } else {
        return e.name;
      }
    }
  };

  billViewNullfunctionCountry = (e) => {
    if (e == null) {
      return " ";
    } else {
      if (e.name == null) {
        return "";
      } else {
        return e.name;
      }
    }
  };

  pdfDownload = (e) => {
    e.preventDefault();

    const token = localStorage.getItem("token");
    const { id } = this.props.params;

    const resspdf = axios
      .get("public/api/purchase/order/pdf/" + id, {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        responseType: "blob",
      })
      .then((resspdf) => {
        const url = window.URL.createObjectURL(new Blob([resspdf.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          this.state.purchaseorderDetails.transaction_series_number + ".pdf"
        ); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
  };

  //Logout function

  logout = async (e) => {
    e.preventDefault();
    var token = localStorage.getItem("token");

    const res = await axios.get("public/api/logout", {
      headers: {
        authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });

    //console.log(res);

    if (res.data.success) {
      localStorage.removeItem("token");

      //Start the timer
      this.setState({ logoutRedirect: true }); //After 1 second, set render to true
    }
  };

  //Logout function

  render() {
    if (this.state.purchaseordertobill) {
      const { id } = this.props.params;
      this.state.purchaseordertobill=false;
      this.setState({purchaseordertobill:this.state.purchaseordertobill});
      return <Navigate to={"/filterby/Purchaseordertobill/" + id} />;
    }

    let token = localStorage.getItem("token");

    if (token == null) {
      return <Navigate to={"/Login"} />;
    }

    if (this.state.logoutRedirect) {
      return <Navigate to={"/Login"} />;
    }

   

    return (
      <>
        {/*
            This example requires updating your template:
    
            ```
            <html class="h-full bg-gray-100">
            <body class="h-full">
            ```
          */}
        <div>
          {" "}
          <div className={this.state.overLay} aria-hidden="true" />
          
          {/* Static sidebar for desktop */}
          
          <div className="flex flex-col flex-1">
           

            <main className="flex-1">
              <div className="py-6">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                  <div className="flex flex-row">
                    <div className="basis-1/4">
                      {" "}
                      <h1 className="text-2xl font-semibold text-gray-900">
                        PURCHASE ORDER
                      </h1>
                    </div>
                    <div className="basis-1/4"></div>
                    <div className="basis-1/4"></div>
                    <div className="basis-1/4 place-content-end">
                      <Menu
                        as="div"
                        className="ml-3 relative inline-block text-left"
                      >
                        <div>
                          <Menu.Button className="-my-2 p-2 rounded-full bg-white flex items-center text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500">
                            <span className="sr-only">Open options</span>
                            <DotsVerticalIcon
                              className="h-5 w-5"
                              aria-hidden="true"
                            />
                          </Menu.Button>
                        </div>

                        <Transition
                          as={Fragment}
                          enter="transition ease-out duration-100"
                          enterFrom="transform opacity-0 scale-95"
                          enterTo="transform opacity-100 scale-100"
                          leave="transition ease-in duration-75"
                          leaveFrom="transform opacity-100 scale-100"
                          leaveTo="transform opacity-0 scale-95"
                        >
                          <Menu.Items className="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                            <div className="py-1">
                              <Menu.Item>
                                {({ active }) => (
                                  <a
                                    href="#"
                                    onClick={this.pdfDownload}
                                    target="__blank"
                                    className={classNames(
                                      active
                                        ? "bg-gray-100 text-gray-900"
                                        : "text-gray-700",
                                      "flex justify-between px-4 py-2 text-sm"
                                    )}
                                  >
                                    <span>Download Pdf</span>
                                  </a>
                                )}
                              </Menu.Item>
                              <Menu.Item>
                                {({ active }) => (
                                  <a
                                    href={
                                      this.state.purchaseordereditLink +
                                      this.state.purchaseorderId
                                    }
                                    className={classNames(
                                      active
                                        ? "bg-gray-100 text-gray-900"
                                        : "text-gray-700",
                                      "flex justify-between px-4 py-2 text-sm"
                                    )}
                                  >
                                    <span>Edit</span>
                                  </a>
                                )}
                              </Menu.Item>
                              <Menu.Item>
                                {({ active }) => (
                                  <button
                                    type="button"
                                    onClick={this.converttobill}
                                    className={classNames(
                                      active
                                        ? "bg-gray-100 text-gray-900"
                                        : "text-gray-700",
                                      "w-full flex justify-between px-4 py-2 text-sm"
                                    )}
                                  >
                                    <span>Convert to Bill</span>
                                  </button>
                                )}
                              </Menu.Item>
                              <Menu.Item>
                                {({ active }) => (
                                  <button
                                    type="button"
                                    onClick={this.Receivedmodal}
                                    className={classNames(
                                      active
                                        ? "bg-gray-100 text-gray-900"
                                        : "text-gray-700",
                                      "w-full flex justify-between px-4 py-2 text-sm"
                                    )}
                                  >
                                    <span>Received</span>
                                  </button>
                                )}
                              </Menu.Item>
                            </div>
                          </Menu.Items>
                        </Transition>
                      </Menu>
                    </div>
                  </div>
                </div>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                  {/* Replace with your content */}

                  <div className="hidden sm:block" aria-hidden="true">
                    <div className="py-5">
                      <div className="border-t border-gray-200" />
                    </div>
                  </div>

                  <div className="mt-10 sm:mt-0">
                    <div className={`md:grid md:gap-6 ${this.state.loader}`}>
                      <div className="mt-5 md:mt-0 md:col-span-2">
                        <form onSubmit={this.udpateItem}>
                          <div className="shadow overflow-hidden sm:rounded-md">
                            <div className="px-4 py-5 bg-white sm:p-6">
                              <div className="px-4 sm:px-6 lg:px-8">
                                <dl className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">
                                  <div className="sm:col-span-1">
                                    <dt className="text-sm font-medium text-gray-500">
                                      {" "}
                                      {this.state.brachDetails.name}
                                    </dt>
                                    <dd className="mt-1 text-sm text-gray-900">
                                      {" "}
                                      {this.state.brachDetails.street_one}
                                    </dd>
                                    <dd className="mt-1 text-sm text-gray-900">
                                      {" "}
                                      {this.state.brachDetails.street_two}
                                    </dd>
                                    <dd className="mt-1 text-sm text-gray-900">
                                      {this.state.brachDetails.city},
                                      {this.state.branchState.name}{" "}
                                      {this.state.brachDetails.zip_postal_code}
                                    </dd>
                                    <dd className="mt-1 text-sm text-gray-900">
                                      {this.state.branchCountry.name}
                                    </dd>
                                    <dd className="mt-1 text-sm text-gray-900">
                                      GSTIN {this.state.brachDetails.gstin}
                                    </dd>
                                  </div>
                                  <div className="sm:col-span-1 text-right">
                                    <dt className="text-sm font-medium text-gray-500">
                                      PURCHASE ORDER
                                    </dt>
                                    <dd className="mt-1 text-sm text-gray-900">
                                      {
                                        this.state.purchaseorderDetails
                                          .transaction_series_number
                                      }
                                    </dd>
                                  </div>
                                  <div className="sm:col-span-1">
                                    <dt className="text-sm font-medium text-gray-500">
                                      Vendor Address
                                    </dt>
                                    <dd className="mt-1 text-sm text-gray-900">
                                      {this.billViewNullfunction(
                                        this.state.vendorDetails.company_name
                                      )}
                                    </dd>
                                    <dd className="mt-1 text-sm text-gray-900">
                                      {this.billViewNullfunction(
                                        this.state.billingAddress
                                          .billing_address_street_one
                                      )}
                                    </dd>
                                    <dd className="mt-1 text-sm text-gray-900">
                                      {this.billViewNullfunction(
                                        this.state.billingAddress
                                          .billing_address_street_two
                                      )}
                                    </dd>
                                    <dd className="mt-1 text-sm text-gray-900">
                                      {this.billViewNullfunction(
                                        this.state.billingAddress.billing_city
                                      )}
                                      ,
                                      {this.billViewNullfunctionState(
                                        this.state.vendorState
                                      )}{" "}
                                      {this.billViewNullfunction(
                                        this.state.billingAddress
                                          .billing_zip_code
                                      )}{" "}
                                    </dd>
                                    <dd className="mt-1 text-sm text-gray-900">
                                      {this.billViewNullfunctionCountry(
                                        this.state.vendorCountry
                                      )}
                                    </dd>
                                    <dd className="mt-1 text-sm text-gray-900">
                                      GSTIN{" "}
                                      {this.billViewNullfunction(
                                        this.state.vendorgstin.gstin_uin
                                      )}
                                    </dd>
                                  </div>
                                  <div className="sm:col-span-1 text-right">
                                    <dt className="text-sm font-medium text-gray-500">
                                      Purchase Order Date :{" "}
                                      {
                                        this.state.purchaseorderDetails
                                          .purchase_order_date
                                      }
                                    </dt>
                                    <dd className="mt-1 text-sm text-gray-900">
                                      Terms : {this.state.paymentTerm.name}
                                    </dd>
                                    <dd className="mt-1 text-sm text-gray-900">
                                      Expected Delivery Date:{" "}
                                      {
                                        this.state.purchaseorderDetails
                                          .expected_delivery_date
                                      }
                                    </dd>
                                    <dd className="mt-1 text-sm text-gray-900"></dd>
                                  </div>

                                  <div className="sm:col-span-2">
                                    <dt className="text-sm font-medium text-gray-500">
                                      Place Of Supply:{" "}
                                    </dt>
                                    <dd className="mt-1 text-sm text-gray-900"></dd>
                                  </div>
                                </dl>
                                <div className="sm:flex sm:items-center">
                                  <div className="sm:flex-auto">
                                    <h1 className="text-xl font-semibold text-gray-900"></h1>
                                    <p className="mt-2 text-sm text-gray-700">
                                      <time dateTime="2022-08-01"></time>
                                      <time dateTime="2022-08-31"></time>
                                    </p>
                                  </div>
                                  <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none"></div>
                                </div>
                                <div className="-mx-4 mt-8 flex flex-col sm:-mx-6 md:mx-0">
                                  <table className="min-w-full divide-y divide-gray-300">
                                    <thead>
                                      <tr>
                                        <th
                                          scope="col"
                                          className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 md:pl-0"
                                        >
                                          Item & Description
                                        </th>
                                        <th
                                          scope="col"
                                          className="hidden py-3.5 px-3 text-right text-sm font-semibold text-gray-900 sm:table-cell"
                                        >
                                          HSN/SAC
                                        </th>
                                        <th
                                          scope="col"
                                          className="hidden py-3.5 px-3 text-right text-sm font-semibold text-gray-900 sm:table-cell"
                                        >
                                          Qty
                                        </th>
                                        <th
                                          scope="col"
                                          className="py-3.5 pl-3 pr-4 text-right text-sm font-semibold text-gray-900 sm:pr-6 md:pr-0"
                                        >
                                          Rate
                                        </th>
                                        {this.state.commonGSTvalue === 2 ? (
                                          <th
                                            scope="col"
                                            className="hidden py-3.5 px-3 text-right text-sm font-semibold text-gray-900 sm:table-cell"
                                          >
                                            IGST
                                          </th>
                                        ) : (
                                          ""
                                        )}

                                        {this.state.commonGSTvalue === 3 ? (
                                          <>
                                            <th
                                              scope="col"
                                              className="hidden py-3.5 px-3 text-right text-sm font-semibold text-gray-900 sm:table-cell"
                                            >
                                              CGST
                                            </th>
                                            <th
                                              scope="col"
                                              className="hidden py-3.5 px-3 text-right text-sm font-semibold text-gray-900 sm:table-cell"
                                            >
                                              SGST
                                            </th>
                                          </>
                                        ) : (
                                          ""
                                        )}

                                        <th
                                          scope="col"
                                          className="py-3.5 pl-3 pr-4 text-right text-sm font-semibold text-gray-900 sm:pr-6 md:pr-0"
                                        >
                                          Amount
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {this.state.items.map((item) => (
                                        <tr
                                          key={item.id}
                                          className="border-b border-gray-200"
                                        >
                                          <td className="py-4 pl-4 pr-3 text-sm sm:pl-6 md:pl-0">
                                            <div className="font-medium text-gray-900">
                                              {item.name},<br />
                                              <span className="text-gray-500 text-sm">
                                                {item.description}
                                              </span>
                                            </div>
                                            <div className="mt-0.5 text-gray-500 sm:hidden"></div>
                                          </td>
                                          <td className="hidden py-4 px-3 text-right text-sm text-gray-500 sm:table-cell">
                                            {item.hsn_code}
                                          </td>
                                          <td className="hidden py-4 px-3 text-right text-sm text-gray-500 sm:table-cell">
                                            {item.quantity}
                                          </td>
                                          <td className="py-4 pl-3 pr-4 text-right text-sm text-gray-500 sm:pr-6 md:pr-0">
                                            {item.rate}
                                          </td>

                                          {this.state.commonGSTvalue === 2 ? (
                                            <td className="py-4 pl-3 pr-4 text-right text-sm text-gray-500 sm:pr-6 md:pr-0">
                                              <div className="font-medium text-gray-900">
                                                {item.igst_amount},{" "}
                                                <span className="text-xs break-after-column	">
                                                  {item.igst_percentage}%
                                                </span>
                                              </div>
                                              <div className="mt-0.5 text-gray-500 sm:hidden"></div>
                                            </td>
                                          ) : (
                                            ""
                                          )}
                                          {this.state.commonGSTvalue === 3 ? (
                                            <>
                                              <td className="py-4 pl-3 pr-4 text-right text-sm text-gray-500 sm:pr-6 md:pr-0">
                                                <div className="font-medium text-gray-900">
                                                  {item.cgst_amount},{" "}
                                                  {item.cgst_percentage}
                                                </div>
                                                <div className="mt-0.5 text-gray-500 sm:hidden"></div>
                                              </td>
                                              <td className="py-4 pl-3 pr-4 text-right text-sm text-gray-500 sm:pr-6 md:pr-0">
                                                <div className="font-medium text-gray-900">
                                                  {item.sgst_amount},{" "}
                                                  {item.sgst_percentage}
                                                </div>
                                                <div className="mt-0.5 text-gray-500 sm:hidden"></div>
                                              </td>
                                            </>
                                          ) : (
                                            ""
                                          )}

                                          <td className="py-4 pl-3 pr-4 text-right text-sm text-gray-500 sm:pr-6 md:pr-0">
                                            {item.amount}
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                    <tfoot>
                                      <tr>
                                        <th
                                          scope="row"
                                          colSpan={5}
                                          className="hidden pl-6 pr-3 pt-6 text-right text-sm font-normal text-gray-500 sm:table-cell md:pl-0"
                                        >
                                          Subtotal
                                        </th>
                                        <th
                                          scope="row"
                                          className="pl-4 pr-3 pt-6 text-left text-sm font-normal text-gray-500 sm:hidden"
                                        >
                                          Subtotal
                                        </th>
                                        <td className="pl-3 pr-4 pt-6 text-right text-sm text-gray-500 sm:pr-6 md:pr-0">
                                          {
                                            this.state.purchaseorderDetails
                                              .sub_total
                                          }
                                        </td>
                                      </tr>
                                      <tr>
                                        <th
                                          scope="row"
                                          colSpan={5}
                                          className="hidden pl-6 pr-3 pt-4 text-right text-sm font-normal text-gray-500 sm:table-cell md:pl-0"
                                        >
                                          Total Tax
                                        </th>
                                        <td className="pl-3 pr-4 pt-6 text-right text-sm text-gray-500 sm:pr-6 md:pr-0">
                                          {
                                            this.state.purchaseorderDetails
                                              .total_tax_amount
                                          }
                                        </td>
                                        <th
                                          scope="row"
                                          className="pl-4 pr-3 pt-4 text-left text-sm font-normal text-gray-500 sm:hidden"
                                        >
                                          Tax1
                                        </th>
                                        {this.state.commonGSTvalue === 2 ? (
                                          <td className="pl-3 pr-4 pt-4 text-right text-sm text-gray-500 sm:pr-6 md:pr-0">
                                            {
                                              this.state.totalTaxamount
                                                .totalIgstAmount
                                            }
                                          </td>
                                        ) : (
                                          ""
                                        )}
                                        {this.state.commonGSTvalue === 3 ? (
                                          <td className="pl-3 pr-4 pt-4 text-right text-sm text-gray-500 sm:pr-6 md:pr-0">
                                            {
                                              this.state.totalTaxamount
                                                .totalCgstSgst
                                            }
                                          </td>
                                        ) : (
                                          ""
                                        )}
                                      </tr>

                                      <tr>
                                        <th
                                          scope="row"
                                          colSpan={5}
                                          className="hidden pl-6 pr-3 pt-4 text-right text-sm font-semibold text-gray-900 sm:table-cell md:pl-0"
                                        >
                                          Total
                                        </th>
                                        <th
                                          scope="row"
                                          className="pl-4 pr-3 pt-4 text-left text-sm font-semibold text-gray-900 sm:hidden"
                                        >
                                          Total
                                        </th>
                                        <td className="pl-3 pr-4 pt-4 text-right text-sm font-semibold text-gray-900 sm:pr-6 md:pr-0">
                                          {
                                            this.state.purchaseorderDetails
                                              .total
                                          }
                                        </td>
                                      </tr>
                                      <tr>
                                        <th
                                          scope="row"
                                          colSpan={5}
                                          className="hidden pl-6 pr-3 pt-4 text-right text-sm font-semibold text-gray-900 sm:table-cell md:pl-0"
                                        ></th>
                                        <th
                                          scope="row"
                                          className="pl-4 pr-3 pt-4 text-left text-sm font-semibold text-gray-900 sm:hidden"
                                        ></th>
                                        <td className="pl-3 pr-4 pt-4 text-right text-sm font-semibold text-gray-900 sm:pr-6 md:pr-0">
                                          {
                                            this.state.purchaseorderDetails
                                              .balance_due
                                          }
                                        </td>
                                      </tr>
                                    </tfoot>
                                  </table>
                                </div>
                              </div>
                            </div>

                            <div className="px-4 py-3 bg-gray-50 text-right sm:px-6"></div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>

                  {/* /End replace */}
                </div>
              </div>
            </main>
          </div>
        </div>
        {/*Start Modal Purchase Order Received statu*/}
        <Transition.Root
          show={this.state.purchaseOrderreceivedModal}
          as={Fragment}
        >
          <Dialog
            as="div"
            className="relative z-10"
            onClose={() => this.setState({ purchaseOrderreceivedModal: false })}
          >
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed z-10 inset-0 overflow-y-auto">
              <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full sm:p-6">
                    <form onSubmit={this.Received}>
                      <div>
                        <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
                          <CheckIcon
                            className="h-6 w-6 text-green-600"
                            aria-hidden="true"
                          />
                        </div>
                        <div className="mt-3 text-center sm:mt-5">
                          <Dialog.Title
                            as="h3"
                            className="text-lg leading-6 font-medium text-gray-900"
                          >
                            Received
                          </Dialog.Title>

                          <div className="mt-2">
                            <div className="grid grid-cols-6 gap-6">
                              <div className="col-span-6 sm:col-span-3">
                                <div>
                                  <label
                                    htmlFor="purchase_order_received_date"
                                    className="sr-only"
                                  >
                                    Received Date
                                  </label>
                                  <input
                                    type="Date"
                                    name="purchase_order_received_date"
                                    id="purchase_order_received_date"
                                    onChange={this.handlereceivedInput}
                                    className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    placeholder="Received  Date"
                                  />
                                </div>
                              </div>
                              <div className="col-span-6 sm:col-span-3">
                                <div>
                                  <label htmlFor="note" className="sr-only">
                                    Note
                                  </label>
                                  <input
                                    type="text"
                                    name="note"
                                    onChange={this.handlereceivedInput}
                                    id="note"
                                    className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    placeholder="Note"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                        <button
                          type="submit"
                          className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:col-start-2 sm:text-sm"
                        >
                          Save
                        </button>
                        <button
                          type="button"
                          className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                          onClick={() =>
                            this.setState({
                              purchaseOrderreceivedModal: false,
                            })
                          }
                        >
                          Cancel
                        </button>
                      </div>
                    </form>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
        {/*End Modal Purchase Order received status */}

        {/*Start  Purchase Order Received statu msg*/}
        <div
          aria-live="assertive"
          className="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start"
        >
          <div className="w-full flex flex-col items-center space-y-4 sm:items-end">
            {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
            <Transition
              show={this.state.showmsg}
              //show={true}
              as={Fragment}
              enter="transform ease-out duration-300 transition"
              enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
              enterTo="translate-y-0 opacity-100 sm:translate-x-0"
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 mt-10">
                <div className="p-4">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <CheckCircleIcon
                        className="h-6 w-6 text-green-400"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="ml-3 w-0 flex-1 pt-0.5">
                      <p className="text-sm font-medium text-gray-900">
                        {this.state.msg}
                      </p>
                      <p className="mt-1 text-sm text-gray-500"></p>
                    </div>
                    <div className="ml-4 flex-shrink-0 flex">
                      <button
                        className="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        onClick={() => {
                          this.setState({ showmsg: false });
                        }}
                      >
                        <span className="sr-only">Close</span>
                        <XIcon className="h-5 w-5" aria-hidden="true" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Transition>
          </div>
        </div>
        {/*End  Purchase Order received status msg*/}
      </>
    );
  }
}

export default (props) => <Purchaseorderview {...props} params={useParams()} />;
